import type { QueryClient } from '@tanstack/react-query';
import { fetchAiStatus, type AiStatusResult } from '../api/ai';

export async function ensureAiStatus(
  queryClient: QueryClient,
  cached?: AiStatusResult | null,
): Promise<AiStatusResult> {
  if (cached) return cached;
  return queryClient.fetchQuery({
    queryKey: ['ai-status'],
    queryFn: fetchAiStatus,
    staleTime: 60_000,
  });
}

export function isAnalysisEnabled(status: AiStatusResult): boolean {
  return Boolean(status.enabled && status.features?.analysis !== false);
}

export function isNamingEnabled(status: AiStatusResult): boolean {
  return Boolean(status.enabled && status.features?.naming !== false);
}

/** True while status is loading or when the server reports AI enabled. */
export function isAiFeatureAvailable(status?: AiStatusResult | null): boolean {
  if (!status) return true;
  return status.enabled !== false && status.billingOk !== false;
}
